import React from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

const PlayerWrapper = styled.div`
    position: relative;
    aspect-ratio: 1;
    background-color: #000;
    
    .react-player {
        position: absolute;
        top: 0;
        left: 0;
    }
`;


export const MobileVideoPlayer = ({ document, defaultPlay, height, ...rest }) => {
    return (
        <PlayerWrapper>
            <ReactPlayer
                url={document.Standard.Url}
                width='100%'
                height='100%'
                playing={defaultPlay}
                controls
                className="react-player"
            />
        </PlayerWrapper>
    );
};

export const VideoPlayer = ({ document, defaultPlay, height, ...rest }) => {

    return (
        <ReactPlayer
            url={document.Standard.Url}
            width='100%'
            height='100%'
            playing={defaultPlay}
            controls
            playsinline
        />
    );
};